import { useShortcut } from '@datacamp/le-shared-components';
import { ChevronLeftIcon, ChevronRightIcon } from '@datacamp/waffles-icons';
import { CollapseContext } from '@datacamp/waffles-resizable-elements';
import Tooltip from '@datacamp/waffles-tooltip';
import * as React from 'react';
import { useCallback, useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const ToggleInstructionsButton = React.memo(() => {
  const {
    collapsedFirstElement: isClosed,
    toggleFirstElement
  } = useContext(CollapseContext);
  const [isHovered, setIsHovered] = useState(false);
  const buttonRef = useRef(null);
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'RemoteDesktopExercise'
  });
  const toolTipText = isClosed ? "".concat(t('ToggleInstructionsButton.showInstructions'), " (Ctrl+B)") : "".concat(t('ToggleInstructionsButton.hideInstructions'), " (Ctrl+B)");
  const toolTipLocation = isClosed ? 'bottomLeft' : 'bottom';
  const left = isClosed ? '-15px' : '-17.5px';
  const iconLeft = isClosed ? '7px' : '5px';
  const Icon = isClosed ? ChevronRightIcon : ChevronLeftIcon;
  const setIsHoveredTrue = useCallback(() => setIsHovered(true), []);
  const setIsHoveredFalse = useCallback(() => setIsHovered(false), []);
  const togglePanel = useCallback(() => {
    toggleFirstElement();
    setIsHovered(false);
  }, [toggleFirstElement]);
  useShortcut({
    handler: togglePanel,
    shortcut: {
      ctrlKey: true,
      key: 'b'
    }
  });
  return ___EmotionJSX("div", {
    className: "dc-panel-button dc-panel exercise__sidebar dc-u-z-10",
    "data-cy": "exercise-panel-collapse",
    onClick: togglePanel,
    onMouseOut: setIsHoveredFalse,
    onMouseOver: setIsHoveredTrue,
    ref: buttonRef,
    style: {
      background: 'rgba(0, 0, 0, 0.4)',
      // opacity can not be removed from children
      border: 'none',
      borderRadius: '50%',
      cursor: 'pointer',
      height: '30px',
      left,
      position: 'absolute',
      top: 'calc( 50% - 15px )',
      width: '30px'
    }
  }, ___EmotionJSX(Tooltip, {
    appearance: "dark",
    id: "OpenSideBarToolTipId",
    position: toolTipLocation,
    target: buttonRef,
    visible: isHovered
  }, toolTipText), ___EmotionJSX("div", {
    style: {
      left: iconLeft,
      position: 'absolute',
      top: '5px'
    }
  }, ___EmotionJSX(Icon, {
    className: "dc-u-z-10",
    color: "white",
    size: "small"
  })));
});
ToggleInstructionsButton.displayName = 'ToggleInstructionsButton';